import { Fragment, FunctionComponent, h } from 'preact'
import { useContext, useMemo, useState } from 'preact/hooks'

import { CesField as CesFieldType } from 'scripts/type'
import { Description, Rating } from 'components/ui'

import { FieldCommonProps } from '../type'
import FieldsContext from '../fieldsContext'
import FieldWrapper from '../components/FieldWrapper'
import { useHandlersWithRequired } from '../hooks'
import usePropValueChange from 'components/business/SurveyForm/Fields/hooks/usePropValueChange'

const CesField: FunctionComponent<FieldCommonProps> = (props) => {
  const { field, required, onFieldSubmit } = props
  const [value, setValue] = useState<number | null>(null)
  const { windowSizeSm } = useContext(FieldsContext)!
  const { onClickHandler, onNext } = useHandlersWithRequired(setValue, required, onFieldSubmit)
  const { ratingMax, ratingMinDescription, ratingMaxDescription } = field as CesFieldType
  usePropValueChange(props, () => setValue(null))

  const handleClick = (value: number) => {
    setValue(value)
    onClickHandler()
  }

  const items = useMemo(
    () =>
      Array.from({ length: ratingMax }, (_, i) => ({
        value: i + 1,
        children: <Fragment>{i + 1}</Fragment>,
      })),
    [ratingMax]
  )

  return (
    <FieldWrapper {...props} handlerProps={{ visible: !required, onNext }}>
      <Description minDescription={ratingMinDescription} maxDescription={ratingMaxDescription} />
      <Rating value={value} items={items} hoverEnable={!windowSizeSm} onClick={handleClick} />
    </FieldWrapper>
  )
}

export default CesField
